window.addEventListener("DOMContentLoaded", (event) => {
if (screen.width > 500) {
/*const main = document.querySelector(".main-content");
main.addEventListener('click', (event) => {
  document.querySelector('.js-drawer-close button').click();
});*/

const footer = document.querySelector(".footer-wrapper");
footer.addEventListener('click', (event) => {
  document.querySelector('.js-drawer-close button').click();
});
}
  if (location.href.includes("tagged")) {
    toggleFilters();
  }
});

function displayForm(formId) {
  var notifyForm = document.querySelector('img[product-id="'+formId+'"] + .da-restock-collection-img-v3-wrapper');
  notifyForm.classList.toggle('revealForm');
}

function toggleFilters() {
  var filters = document.querySelector('.recipe-filters');
  filters.classList.toggle('revealFilters'); 
}

/* Dropdown */
function filterRecipes() {
  var diet = document.querySelector('#diet-filter').value.toLowerCase();    
  var type = document.querySelector('#type-filter').value.toLowerCase();
  var redirectUrl = '/blogs/recipes/';
  const tags = [];
  if (diet != "all") { tags.push(diet); }
  if (type != "all") { tags.push(type); }
  var tagString = tags.join("+");
  if (tagString == "") {
    location.href = redirectUrl;        
  } else {
    location.href = redirectUrl + "tagged/" + tagString;    
  }
}

function navOpen() {
  var menuBtn = document.querySelector('.js-drawer-open-left-link');    
  menuBtn.classList.toggle("menu-open");
}

function filterRecipesCheckbox() {
  var redirectUrl = '/blogs/recipes/';
  const tags = [];
  var checkedBoxes = document.querySelectorAll('input[type="checkbox"]:checked');
  
  for (var i = 0; i < checkedBoxes.length; i++) {   
    if (checkedBoxes[i].name !== 'optInText') {
      tags.push(checkedBoxes[i].name);
    }
  }   
  var tagString = tags.join("+");
  if (tagString == "") {
    newUrl = redirectUrl;        
  } else {
    newUrl = redirectUrl + "tagged/" + tagString;    
  }

  location.href = newUrl;        
}

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".jump-links").forEach(function (wrapper) {
    const container = wrapper.querySelector("ul");
    const links = container ? container.querySelectorAll("a") : [];

    if (!container || links.length === 0) return;

    const dotsContainer = document.createElement("div");
    dotsContainer.className = "jump-dots";
    wrapper.appendChild(dotsContainer);

    links.forEach((_, i) => {
      const dot = document.createElement("span");
      if (i === 0) dot.classList.add("active");
      dotsContainer.appendChild(dot);
    });

    const dots = dotsContainer.querySelectorAll("span");

    function updateActiveDot() {
      const maxScroll = container.scrollWidth - container.clientWidth;

      if (container.scrollLeft >= maxScroll - 5) {
        dots.forEach(dot => dot.classList.remove("active"));
        dots[dots.length - 1].classList.add("active");
        return;
      }

      let closestIndex = 0;
      let closestOffset = Infinity;

      links.forEach((link, i) => {
        const offset = Math.abs(link.offsetLeft - container.scrollLeft);

        if (offset < closestOffset) {
          closestOffset = offset;
          closestIndex = i;
        }
      });

      dots.forEach(dot => dot.classList.remove("active"));
      dots[closestIndex].classList.add("active");
    }

    container.addEventListener("scroll", updateActiveDot);
  });
});

(function () {
  if (window.wasabiFaqSchemaDone) return;
  window.wasabiFaqSchemaDone = true;

  function cleanTextFromElement(element) {
    var clone = element.cloneNode(true);

    clone.querySelectorAll('img, picture, svg, video, iframe, script, style').forEach(function (el) {
      el.remove();
    });

    return clone.textContent.replace(/\s+/g, ' ').trim();
  }

  function buildFaqSchemaFromPage() {
    var faqItems = document.querySelectorAll('.accordion--faq-wrapper .accordion-content');

    if (!faqItems.length) return;

    var seen = {};
    var mainEntity = [];

    faqItems.forEach(function (item) {
      var questionEl = item.querySelector('.text-with-icon--text');
      var answerEl = item.querySelector('.rte');

      if (!questionEl || !answerEl) return;

      var question = cleanTextFromElement(questionEl);
      var answer = cleanTextFromElement(answerEl);

      if (!question || !answer) return;

      // Ignore default placeholder blocks
      if (question === 'Place your question or heading here') return;
      if (answer === 'Here you can place an explanation or answer to the question.') return;

      var key = question.toLowerCase();

      if (seen[key]) return;
      seen[key] = true;

      mainEntity.push({
        "@type": "Question",
        "name": question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": answer
        }
      });
    });

    if (!mainEntity.length) return;

    var schema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": mainEntity
    };

    document.querySelectorAll('script[data-generated-faq-schema]').forEach(function (script) {
      script.remove();
    });

    var output = document.createElement('script');
    output.type = 'application/ld+json';
    output.setAttribute('data-generated-faq-schema', 'true');
    output.textContent = JSON.stringify(schema);

    document.head.appendChild(output);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildFaqSchemaFromPage);
  } else {
    buildFaqSchemaFromPage();
  }
})();